import qs from 'query-string';
export default function updateURL(query) {
  if (query && (query === null || query === void 0 ? void 0 : query.m)) delete query.m;
  var newqs = qs.stringify(query);
  var toset = "".concat(this.isEmpty(query) ? '' : '?').concat(newqs);
  window.history.replaceState(null, null, toset || window.location.pathname);
}